
export const apiUrl =  process.env.REACT_APP_API_URL;
export const reactUrl =  process.env.PUBLIC_URL;

